import linkResolver from "../../linkResolver";

/**
 * Custom hook to resolve redirect URLs for internal or external links
 * @param {Object} redirectLink - The redirect link object from Prismic
 * @returns {string|null} - Resolved URL or null if no valid redirect
 */
export const useRedirectUrl = (redirectLink) => {
  if (!redirectLink) return null;

  try {
    // External URL
    if (redirectLink.url) {
      return redirectLink.url;
    }

    // Internal Prismic document
    if (redirectLink.document) {
      const resolvedUrl = linkResolver(redirectLink.document);
      if (!resolvedUrl) {
        console.warn(
          "Failed to resolve internal document link:",
          redirectLink.document,
        );
      }
      return resolvedUrl;
    }

    return null;
  } catch (error) {
    console.error("Error resolving redirect URL:", error);
    return null;
  }
};
